<i18n
  src="@/locales/views/customer/reporting/process/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_reporting_process_list_agro_exporters_path"
    :params="{
      customer_id: customer_id
    }"
  />

  <bread-crumbs :labels="[module_name, agro_exporter?.name]"></bread-crumbs>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md mt-8"
  >
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="agro_exporter_process in agro_exporter_processes"
        :key="agro_exporter_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowReports(agro_exporter_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agro_exporter_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>{{ $t("labels.show_link") }}
                </a>
              </div>
            </div>

            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex space-x-0 sm:space-x-6">
                <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                  <i
                    class="fa-solid fa-container-storage flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.number_containers_with_inspects }} /
                  {{ agro_exporter_process.number_containers }}
                </p>
                <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                  <i
                    class="fa-solid fa-box-check flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.number_inspects }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/reporting/process/list_processes.js";

export default {
  name: "CustomerReportingProcessListAgroExporters",
  props: {
    customer_id: { required: true },
    agro_exporter_id: { required: true }
  },
  data: function () {
    return {
      load_data_general: false,
      agro_exporter: {},
      agro_exporter_processes: []
    };
  },
  methods: {
    fetchAgroExporter: async function () {
      const response = await Requester.fetchAgroExporter(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter = response.data;
    },
    fetchAgroExporterProcesses: async function () {
      const response = await Requester.fetchAgroExporterProcesses(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter_processes = response.data;
      this.load_data_general = true;
    },
    goToShowReports: function (agro_exporter_process) {
      this.$router.push({
        name: "customer_reporting_process_list_reports_path",
        params: {
          customer_id: this.customer_id,
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: agro_exporter_process.id
        }
      });
    }
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchAgroExporterProcesses();
      })
    );
  }
};
</script>
